import React from "react";
import "./FastCasinoSoftwareStyle.scss";
import { fastCasinoSoftwareTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const FastCasinoSoftwareSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/`);
  };

  return (
    <section className="fast-casino-software-section">
      <div className="fast-casino-software-wrap">
        <SectionHeading>{fastCasinoSoftwareTextContent.headingText}</SectionHeading>

        <div className="fast-casino-software-box">
          <div className="text-box">
            <p className="para-text">{fastCasinoSoftwareTextContent.paraText}</p>

            <div className="btn-box">
              <CustomButton
                buttonType="black"
                label={fastCasinoSoftwareTextContent.btnText}
                onClick={handleButtonClick}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FastCasinoSoftwareSection;
